import { render } from "./chBet.vue?vue&type=template&id=d3400942"
import script from "./chBet.vue?vue&type=script&lang=js"
export * from "./chBet.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__